import { render, staticRenderFns } from "./viewProfile.vue?vue&type=template&id=5fd51658"
import script from "./viewProfile.vue?vue&type=script&lang=js"
export * from "./viewProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports